import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { changePassword } from "Api/UserApi";
import {
  checkStatusCodeSuccess,
  loginLabels,
} from "Components/constants/Common";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import BaseInput from "Components/Base/BaseInput";
import {
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import BaseButton from "Components/Base/BaseButton";

const ChangePassword: React.FC = () => {
  document.title = loginLabels.changePassword;

  const navigate = useNavigate();

  const [submitLoader, setSubmitLoader] = useState<boolean>(false);

  const validation = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required(
        validationMessages.required(loginLabels.CurrentPassword)
      ),
      newPassword: Yup.string()
        .required(validationMessages.required(loginLabels.NewPassword))
        .min(8, validationMessages.passwordLength(loginLabels.Password, 8)),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref(loginLabels.newPassword), ""],
          validationMessages.passwordsMatch(
            loginLabels.NewPassword,
            loginLabels.ConfirmPassword
          )
        )
        .required(validationMessages.required(loginLabels.ConfirmPassword)),
    }),
    onSubmit: async (values) => {
      setSubmitLoader(true);
      const payload = {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      };

      changePassword(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            navigate("/login");
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          if (error?.status === 401) {
            toast.error(
              "Access Denied! You do not have permission to access this module."
            );
          } else {
            toast.error(error?.response?.data?.message || error?.message);
          }
        })
        .finally(() => setSubmitLoader(false));
    },
  });

  return (
    <div className="page-content">
    <div className=" d-flex justify-content-end">
    <button
          className="btn btn-danger d-flex justify-content-end"
          onClick={() => navigate("/dashboard")}
        >
          <i className="mdi mdi-arrow-left" />
        </button>
        </div>
    <div className=" d-flex justify-content-center align-items-center">
     
      <div className="card w-500 mt-4">
      
        <Row>
          <Col sm={12}>
            <div className="p-4">
              <div className="text-center mb-4">
                <h5 className="text-primary">{loginLabels.changePassword}</h5>
              </div>
              <form onSubmit={validation.handleSubmit}>
                <div className="mb-3">
                  <BaseInput
                    type="password"
                    label={loginLabels.CurrentPassword}
                    className="form-control pe-5 password-input"
                    placeholder={InputPlaceHolder(loginLabels.CurrentPassword)}
                    name={loginLabels.currentPassword}
                    value={validation.values.currentPassword}
                    onChange={validation.handleChange}
                    handleBlur={validation.handleBlur}
                    touched={validation.touched.currentPassword}
                    error={validation.errors.currentPassword}
                    required
                  />
                </div>

                <div className="mb-3">
                  <BaseInput
                    type="password"
                    label={loginLabels.NewPassword}
                    className="form-control pe-5 password-input"
                    placeholder={InputPlaceHolder(loginLabels.NewPassword)}
                    name={loginLabels.newPassword}
                    value={validation.values.newPassword}
                    onChange={validation.handleChange}
                    handleBlur={validation.handleBlur}
                    touched={validation.touched.newPassword}
                    error={validation.errors.newPassword}
                    required
                  />
                </div>

                <div className="mb-3">
                  <BaseInput
                    type="password"
                    label={loginLabels.ConfirmNewPassword}
                    className="form-control pe-5 password-input"
                    placeholder={InputPlaceHolder(
                      loginLabels.ConfirmNewPassword
                    )}
                    name={loginLabels.confirmPasswordName}
                    value={validation.values.confirmPassword}
                    onChange={validation.handleChange}
                    handleBlur={validation.handleBlur}
                    touched={validation.touched.confirmPassword}
                    error={validation.errors.confirmPassword}
                    required
                  />
                </div>

                <BaseButton
                  color="success"
                  type="submit"
                  label={loginLabels.changePassword}
                  loader={submitLoader}
                  className="w-100"
                />
              </form>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    </div>
  );
};

export default ChangePassword;
